import { createElement } from 'react';
import { bool, string } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { RatingStar as RatingStar$1 } from './styled.js';

var RatingStar = function RatingStar(_ref) {
  var size = _ref.size,
      active = _ref.active,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "active"]);

  return (// @ts-ignore
    createElement(RatingStar$1, _extends({
      use: "svg",
      size: size,
      active: active,
      viewBox: "0 0 24 24"
    }, props), createElement("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    }))
  );
};

var ratingStarPropTypes = {
  active: bool,
  size: string
};
RatingStar.propTypes = ratingStarPropTypes;
var ratingStarDefaultProps = {
  size: 'default',
  active: false
};
RatingStar.defaultProps = ratingStarDefaultProps; // @ts-ignore

var C = RatingStar;
export default C;
export { RatingStar, ratingStarDefaultProps, ratingStarPropTypes };